import { getHandlebarsSnippetTagFromString } from './getHandlebarsSnippetTagFromString';
import { getSnippetNameFromMustacheStatement } from './getSnippetNameFromMustacheStatement';

export const getSnippetNameFromString = (content: string): string | null => {
  const snippetStatement = getHandlebarsSnippetTagFromString(content);
  return getSnippetNameFromMustacheStatement(snippetStatement);
};
